// pp-fiscal-alert.js — Aviso de datos fiscales faltantes (rail + dashboard).
//
// El estado fiscal del cliente vive en el CRM, no en Shopify, así que se
// resuelve por JS vía el App Proxy /apps/crm/customer-fiscal. Si el cliente no
// tiene NINGÚN perfil fiscal, marca el item "Facturación" del rail con un aviso
// rojo y, en el dashboard, inyecta un banner que lleva a registrarlos.
//
// Se carga desde el rail (presente en todas las páginas del account). Cachea el
// booleano en sessionStorage; pp-customer-fiscal.js refresca ese cache cuando el
// cliente agrega o elimina un perfil, para que el aviso aparezca/desaparezca sin
// recargar toda la sesión. Ver docs/facturacion-perfil-cliente.md.

(function () {
  'use strict';

  var ENDPOINT = '/apps/crm/customer-fiscal';
  // Cache aislado por cliente: sessionStorage sobrevive a logout/login en la misma
  // pestaña; la key lleva el customer.id para no filtrar el estado de otro usuario.
  var railEl = document.querySelector('[data-pp-customer]');
  var CACHE_KEY = 'pp_has_fiscal_data:' + ((railEl && railEl.getAttribute('data-pp-customer')) || 'anon');

  var railBadge = document.querySelector('[data-pp-rail-fiscal-count]');
  var slot = document.querySelector('[data-pp-fiscal-alert-slot]');
  var tpl = document.querySelector('[data-pp-fiscal-alert-tpl]');

  // Sin ninguno de los dos destinos no hay nada que hacer.
  if (!railBadge && !slot) return;

  function showRailBadge() {
    if (!railBadge) return;
    railBadge.textContent = '!';
    railBadge.classList.add('pp-rail__badge--alert');
    var label = railBadge.getAttribute('data-t-label');
    if (label) railBadge.setAttribute('aria-label', label);
    railBadge.hidden = false;
  }

  function showBanner() {
    if (!slot || !tpl || !tpl.content) return;
    if (slot.firstChild) return; // ya inyectado
    slot.appendChild(tpl.content.cloneNode(true));
    slot.hidden = false;
  }

  function applyMissing() {
    showRailBadge();
    showBanner();
  }

  // Cache de sesión (lo mantiene pp-customer-fiscal.js cuando el cliente edita).
  try {
    var cached = sessionStorage.getItem(CACHE_KEY);
    if (cached === 'yes') return;              // ya tiene datos → nada que avisar
    if (cached === 'no') { applyMissing(); return; }
  } catch (_) {}

  // En el editor del theme no hay sesión de cliente.
  if (window.Shopify && window.Shopify.designMode) return;

  // Origen del JSON: la capa PPAccount (prefetch + dedup, arranca en el parse)
  // si existe; si no, fetch directo — así otras páginas sin PPAccount no rompen.
  (window.PPAccount
    ? window.PPAccount.get('customer-fiscal')
    : fetch(ENDPOINT, { method: 'GET', credentials: 'same-origin' }).then(function (r) { return r.json().catch(function () { return null; }); }))
    .then(function (d) {
      if (!d) return; // error de red → no molestar
      var hasAny = !!(d.profiles && d.profiles.length > 0);
      try { sessionStorage.setItem(CACHE_KEY, hasAny ? 'yes' : 'no'); } catch (_) {}
      if (!hasAny) applyMissing();
    })
    .catch(function () {});
})();
